export function condenseAddress(address, length) {
    const partsLength = Math.floor(length / 2);
    return `${address.slice(0, partsLength)}..${address.slice(-partsLength)}`;
}
